import { type UseQueryResult, useQuery } from 'react-query';
import { MaritalStatusService } from '../../services/wealthlane-customer-services';

const useGetMaritalStatus = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const MaritalStatusList = useQuery(
    ['getMaritalStatusList'],
    async () => {
      return await handleRequest(
        MaritalStatusService.getApiCustomerApiAppMaritalStatusMaritalStatusList()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return MaritalStatusList;
};

export default useGetMaritalStatus;
